import { paroApi } from '../httpService';


const getMembers = async (query: any) => {
    try {
        const result = await paroApi.get('users', {
            params: query
        });

        return {
            success: true,
            data: result.data.data,
            pager: result.data.pager || { page: 1, pageSize: 10, totalCount: 0 }
        };
    } catch (error: any) {
        return {
            success: false,
            message: "An unexpected Error"
        };
    }
}


export default {
    getMembers
}